import { render, staticRenderFns } from "./PPlainBoard.vue?vue&type=template&id=7e0ef3ba&"
import script from "./PPlainBoard.vue?vue&type=script&lang=ts&"
export * from "./PPlainBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports